/** Подпись «N ответов» под L2 без тяжёлых i18n. */
export function formatRepliesCountRu(n: number): string {
    if (!Number.isFinite(n) || n <= 0) return "0 ответов"
    const mod10 = n % 10
    const mod100 = n % 100
    if (mod10 === 1 && mod100 !== 11) return `${n} ответ`
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return `${n} ответа`
    return `${n} ответов`
}
